// Client for Search Term Performance.
//
// Its own endpoints, not the Search Terms ones: the two surfaces answer to
// different documents and must be able to change independently.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/term-performance`;

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

export class NotConnectedError extends Error {
  constructor(message) {
    super(message || 'Amazon account not connected');
    this.notConnected = true;
  }
}

const call = async (url, options) => {
  const res = await fetch(url, options);
  const data = await res.json().catch(() => ({}));
  if (res.status === 409 && data.connected === false) throw new NotConnectedError(data.error);
  if (!res.ok || !data.success) throw new Error(data.error || `Request failed (${res.status})`);
  return data;
};

const query = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') search.set(k, v);
  });
  return search.toString();
};

export const getOverview = (token, params) =>
  call(`${BASE}/overview?${query(params)}`, { headers: headers(token) });

// SF1, SF2 and SF4 — one list, three views.
export const getTerms = (token, params) =>
  call(`${BASE}/terms?${query(params)}`, { headers: headers(token) });

export const getBrandedSplit = (token, params) =>
  call(`${BASE}/branded-split?${query(params)}`, { headers: headers(token) });

export const getCannibalization = (token, params) =>
  call(`${BASE}/cannibalization?${query(params)}`, { headers: headers(token) });

export const getTerm = (token, term, params) =>
  call(`${BASE}/term/${encodeURIComponent(term)}?${query(params)}`,
       { headers: headers(token) });

// Seller corrections persist across periods — a ratio that resets each period
// cannot be tracked.
export const reclassify = (token, searchTerm, label) =>
  call(`${BASE}/classification`, {
    method: 'PUT', headers: headers(token),
    body: JSON.stringify({ search_term: searchTerm, label }),
  });
